"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatStripeBillingAddress = void 0;
const src_1 = require("..");
function formatStripeBillingAddress(card, payerName = '', payerPhone = '') {
    const { firstName, lastName } = (0, src_1.getFirstAndLastName)(payerName);
    const { code: provinceCode, name: provinceName } = (0, src_1.getProvinceDetails)(card.address_country, card.address_state);
    const countryName = (0, src_1.getCountryName)(card.address_country);
    const formattedAddress = {
        'first_name': firstName,
        'last_name': lastName,
        'address_line_1': card.address_line1,
        'address_line_2': card.address_line2,
        'country': countryName,
        'city': card.address_city,
        'province': provinceName,
        'country_code': card.address_country,
        'province_code': provinceCode,
        'postal_code': card.address_zip,
        'business_name': '',
        'phone_number': payerPhone
    };
    if (formattedAddress.postal_code.length <= 4 && formattedAddress.country_code === 'CA') {
        formattedAddress.postal_code += '1A1'; //adding default postal code because stripe only provide first 3 digits until the payment is done.
    }
    return formattedAddress;
}
exports.formatStripeBillingAddress = formatStripeBillingAddress;
